import {ref} from 'vue';
import {onNuxtReady} from '#imports';

export function useHydrationState() {
    const isHydrated = ref(false);

    onNuxtReady(() => {
        isHydrated.value = true;
    });

    return {
        isHydrated,
    };
}
